import { memo } from 'react';
/**
 * Является React.memo, но добавляет возможность использовать с generic компонентами.
 *
 * @example
 * ```typescript
 * import { genericMemo } from '@direct-frontend/stdlib';
 *
 * interface MemoizedGenericComponentProps<SomeType> {
 *     field: SomeType;
 * }
 *
 * // MemoizedGenericComponent будет иметь generic пропсы MemoizedGenericComponentProps<SomeType>
 * const MemoizedGenericComponent = genericMemo(<SomeType>(props: MemoizedGenericComponentProps<SomeType>) => {
 *     return ...;
 * });
 * ```
 *
 * @returns React.Component
 */
export const genericMemo = memo;
